import moment from 'moment-timezone'

// The backend sends every time in UTC (ISO strings with Z); these helpers convert them to the selected timezone.

export const getErrorMessage = (error, fallback) => error?.message || fallback

export const formatProvider = (provider) =>
  provider ? provider.charAt(0).toUpperCase() + provider.slice(1) : 'Unknown'

const formatTime = (iso, timezone) => moment(iso).tz(timezone).format('h:mm A')

export const formatTimeRange = (evt, timezone) =>
  evt.isAllDay
    ? 'All day'
    : `${formatTime(evt.start, timezone)} – ${formatTime(evt.end, timezone)}`

// Overlap check, not a start-date check: an event that crosses midnight appears on both days
export const getEventsForDay = (events, dateStr, timezone) => {
  if (!dateStr) return []
  const start = moment.tz(dateStr, 'YYYY-MM-DD', timezone)
  const end = start.clone().add(1, 'day')
  return events
    .filter(
      (evt) =>
        moment(evt.start).isBefore(end) && moment(evt.end).isAfter(start),
    )
    .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf())
}

// id is not unique across calendars, so the key includes provider, calendar name, start and position
export const getEventKey = (evt, index) =>
  `${evt.calendar?.provider}|${evt.calendar?.name}|${evt.id}|${evt.start}|${index}`
